import StoreSelectorConnector from './storeSelector.props';
import StoreSelectorComponent from './storeSelector.component';

export default StoreSelectorConnector(StoreSelectorComponent);
